// The underlying promise keeps running after the timeout, it cannot be cancelled.
// This only stops us from waiting on it so the caller can fail with a clear reason.
export function WithTimeout<T>(promise: Promise<T>, timeoutMs: number, label: string): Promise<T> {
	let timer: ReturnType<typeof setTimeout>
	const timeout = new Promise<never>((_, reject) => {
		timer = setTimeout(() => reject(new Error(`${label} timed out`)), timeoutMs)
	})
	return Promise.race([promise, timeout]).finally(() => clearTimeout(timer))
}

export function Delay(milliseconds: number): Promise<void> {
	return new Promise((resolve) => setTimeout(resolve, milliseconds))
}
